import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@/utils/icons';
import { PROFESSION_PALETTE } from './professionPalette';
import styles from './ColorSwatchPicker.module.css';

interface IColorSwatchPickerProps {
  value: string | null; // Currently selected color (hex), or null when nothing is picked yet.
  onChange: (color: string) => void;
}

export function ColorSwatchPicker({ value, onChange }: IColorSwatchPickerProps) {
  const { t } = useTranslation();
  const colors =
    value && !PROFESSION_PALETTE.includes(value.toLowerCase())
      ? [value, ...PROFESSION_PALETTE]
      : PROFESSION_PALETTE;

  return (
    <div className={styles.swatchGrid} role="radiogroup" aria-label={t('adminProfessions.field.color')}>
      {colors.map((color) => {
        const selected = value?.toLowerCase() === color.toLowerCase();
        return (
          <button
            key={color}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={color}
            className={selected ? `${styles.swatch} ${styles.swatchSelected}` : styles.swatch}
            style={{ backgroundColor: color }}
            onClick={() => onChange(color)}
          >
            {selected && <CheckIcon size={14} />}
          </button>
        );
      })}
    </div>
  );
}
